// ==================================================================================== HERO SECTION ENTRY
gsap.set(".co-main-product", { opacity: 0 });
gsap.set(".co-header-spacer", { opacity: 0 });
gsap.to(".co-main-product", {
  opacity: 1,
  duration: 1
});
gsap.to(".co-header-spacer", {
  opacity: 1,
  duration: 1,
  delay: 0.5
});
// ==================================================================================== HERO SECTION
if (!document.documentElement.classList.contains('shopify-design-mode')) {
  coMM.add("(min-width: 750px)", () => {
    ScrollTrigger.create({
      // markers: true,
      trigger: ".co-main-product",
      start: "top top",
      end: "bottom bottom",
      pinSpacing: false,
      pin: "media-gallery.product__column-sticky"
    });
  })
}

function createAccordionAnimation(
  containerSelector,
  groupSelector,
  menuSelector,
  contentSelector,
  openIconSelector,
  closeIconSelector,
  toggleFirstMenu = false
) {
  let groups = gsap.utils.toArray(groupSelector, document.querySelector(containerSelector));
  let menus = gsap.utils.toArray(menuSelector, document.querySelector(containerSelector));
  let menuToggles = groups.map(createAnimation);

  menus.forEach((menu) => {
    menu.addEventListener("click", () => toggleMenu(menu));
  });

  function toggleMenu(clickedMenu) {
    menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
    // Refresh ScrollTrigger points after any menu is toggled
    gsap.delayedCall(0.3, () => ScrollTrigger.refresh());
  }

  function createAnimation(element) {
    let menu = element.querySelector(menuSelector);
    let box = element.querySelector(contentSelector);
    let minusElement = element.querySelector(openIconSelector);
    let plusElement = element.querySelector(closeIconSelector);

    gsap.set(box, { height: "auto" });

    let animation = gsap
      .timeline()
      .from(box, {
        height: 0,
        duration: 0.3,
        ease: "power2.inOut",
        onComplete: () => ScrollTrigger.refresh() // Ensure refresh after the animation completes
      })
      .from(minusElement, { duration: 0.1, autoAlpha: 0, ease: "none" }, 0)
      .to(plusElement, { duration: 0.1, autoAlpha: 0, ease: "none" }, 0)
      .reverse();

    return function (clickedMenu) {
      if (clickedMenu === menu) {
        animation.reversed(!animation.reversed());
      } else {
        animation.reverse();
      }
    };
  }

  if (toggleFirstMenu && menus.length > 0) {
    toggleMenu(menus[0]);
  }
}


// ========================================== ACCORDION FUNCTION
createAccordionAnimation(
  ".co-product-hero-accordion",       
  ".co-product-hero-accordion-group",
  ".co-product-hero-accordion-menu",  
  ".co-product-hero-accordion-content", 
  ".co-product-hero-accordion-open",   
  ".co-product-hero-accordion-close",
  false
);
// ==================================================================================== SECTION 2
createAccordionAnimation(
  ".co-product-section-2-accordion",       
  ".co-product-section-2-accordion-group",
  ".co-product-section-2-accordion-menu",  
  ".co-product-section-2-accordion-content", 
  ".co-product-section-2-accordion-open",   
  ".co-product-section-2-accordion-close",
  false
);
// ==================================================================================== SECTION 3
// ===================================================== 2 POSITIONS AWAY FROM ACTIVE CLASS
Flickity.createMethods.push('_createPrevNextCells');
Flickity.prototype._createPrevNextCells = function() {
  this.on( 'select', this.setPrevNextCells );
};
Flickity.prototype.setPrevNextCells = function() {
  changeSlideClasses( this.previousSlide, 'remove', 'is-previous' );
  changeSlideClasses( this.nextSlide, 'remove', 'is-next' );
  changeSlideClasses( this.previousPreviousSlide, 'remove', 'is-previous-previous' );
  changeSlideClasses( this.nextNextSlide, 'remove', 'is-next-next' );
  var previousI = fizzyUIUtils.modulo( this.selectedIndex - 1, this.slides.length );
  var nextI = fizzyUIUtils.modulo( this.selectedIndex + 1, this.slides.length );
  var previousPreviousI = fizzyUIUtils.modulo( this.selectedIndex - 2, this.slides.length );
  var nextNextI = fizzyUIUtils.modulo( this.selectedIndex + 2, this.slides.length );
  this.previousSlide = this.slides[ previousI ];
  this.nextSlide = this.slides[ nextI ];
  this.previousPreviousSlide = this.slides[ previousPreviousI ];
  this.nextNextSlide = this.slides[ nextNextI ];
  changeSlideClasses( this.previousSlide, 'add', 'is-previous' );
  changeSlideClasses( this.nextSlide, 'add', 'is-next' );
  changeSlideClasses( this.previousPreviousSlide, 'add', 'is-previous-previous' );
  changeSlideClasses( this.nextNextSlide, 'add', 'is-next-next' );
};
function changeSlideClasses( slide, method, className ) {
  if ( !slide ) {
    return;
  }
  slide.getCellElements().forEach( function( cellElem ) {
    cellElem.classList[ method ]( className );
  });
}
// ========================================================================================================== REUSABLE MARQUEE FUNCTION
function coInitializeTickerCarousel({ 
  selector = '', 
  tickerSpeed = 1, 
  prevNextButtons = true,
  rightScroll = false 
}) {
  let flickity = null;
  let isPaused = false;
  const slideshowEl = document.querySelector(selector);
  if (!slideshowEl) {
    console.error(`Element with selector "${selector}" not found.`);
    return;
  }
  const update = () => {
    if (isPaused) return;
    if (flickity.slides) {
      const direction = rightScroll ? tickerSpeed : -tickerSpeed;
      flickity.x = (flickity.x + direction) % flickity.slideableWidth;
      flickity.selectedIndex = flickity.dragEndRestingSelect();
      flickity.updateSelectedSlide();
      flickity.settle(flickity.x);
    }
    window.requestAnimationFrame(update);
  };
  const pause = () => {
    isPaused = true;
  };
  const play = () => {
    if (isPaused) {
      isPaused = false;
      window.requestAnimationFrame(update);
    }
  };
  flickity = new Flickity(slideshowEl, {
    autoPlay: false,
    pageDots: false,
    draggable: true,
    prevNextButtons: prevNextButtons,
    wrapAround: true,
    selectedAttraction: 0.015,
    friction: 0.25,
    on: {
      ready: function() {
        // ===================================================== GSAP
        const coHomeSection9Items = [
          document.querySelector('.co-product-section-3-blog-slider .is-previous-previous .co-product-section-3-blog-item-frame-1'),
          document.querySelector('.co-product-section-3-blog-slider .is-previous .co-product-section-3-blog-item-frame-1'),
          document.querySelector('.co-product-section-3-blog-slider .is-selected .co-product-section-3-blog-item-frame-1'),
          document.querySelector('.co-product-section-3-blog-slider .is-next .co-product-section-3-blog-item-frame-1'),
          document.querySelector('.co-product-section-3-blog-slider .is-next-next .co-product-section-3-blog-item-frame-1')
        ].filter(item => item !== null);

        gsap.set('.co-product-section-3-main-title', { opacity: 0, y: 0, transition: 0 });
        gsap.set('.co-product-section-3-blog-slider-wrapper', { opacity: 0, transition: 0 });
        gsap.set('.co-product-section-3-main-button', { opacity: 0, y: 0, transition: 0 });
        gsap.set('.co-product-section-3-main-description', { opacity: 0, y: 0, transition: 0 });
        
        let coHomeSection9Timeline = gsap.timeline({ paused: true });
        coHomeSection9Timeline.to(".co-product-section-3-blog-slider-wrapper", {
          duration: 0.3,
          opacity: 1
        });
        coHomeSection9Timeline.fromTo(coHomeSection9Items, { opacity: 0, yPercent: 0, xPercent: 20 }, { opacity: 1, yPercent: 0, xPercent: 0, stagger: 0.1, duration: 1 }, "-=0.6");

        ScrollTrigger.create({
          trigger: '.co-product-section-3-blog-slider-wrapper', start:'top bottom', end: "bottom top",
          animation: coHomeSection9Timeline
        });

      }
    }
  });
  flickity.x = 0;
  slideshowEl.addEventListener('mouseenter', pause, false);
  slideshowEl.addEventListener('focusin', pause, false);
  slideshowEl.addEventListener('mouseleave', play, false);
  slideshowEl.addEventListener('focusout', play, false);
  flickity.on('dragStart', () => {
    isPaused = true;
  });
  update();
}
// ========================================================================================================== SECTION 2
let coProductSection2FactorPos = 20;
let coProductSection2FactorNeg = -20;
let coProductSection2ScrubFactorPos = 20;
let coProductSection2ScrubFactorNeg = -20;
gsap.set(".co-product-section-2-images-frame-3-item-1", { x: coProductSection2FactorPos, y: coProductSection2FactorNeg, scale: 1.1 });
gsap.set(".co-product-section-2-images-frame-3-item-2", { x: coProductSection2FactorNeg, y: coProductSection2FactorNeg, scale: 1.1 });
gsap.set(".co-product-section-2-images-frame-3-item-3", { x: coProductSection2FactorNeg, y: coProductSection2FactorPos, scale: 1.1 });
gsap.set(".co-product-section-2-images-frame-3-item-4", { x: coProductSection2FactorPos, y: coProductSection2FactorPos, scale: 1.1 });
gsap.to(".co-product-section-2-images-frame-3", {
  scrollTrigger: {
    trigger: ".co-product-section-2-images",
    start: "top bottom",
    end: "bottom top"
  },
  x: 0,
  y: 0,
  scale: 1,
  duration: 1,
  ease: "power2.out"
});
gsap.set(".co-product-section-2-content", { opacity: 0 });
gsap.to(".co-product-section-2-content", {
  scrollTrigger: {
    trigger: ".co-product-section-2-content",
    start: "top bottom",
    end: "bottom top"
  },
  opacity: 1,
  duration: 1
});
// SCRUB
// 1
gsap.to(".co-product-section-2-images-frame-3-item-1>div", {
  scrollTrigger: {
    trigger: ".co-product-section-2-images",
    start: "top bottom",
    end: "bottom top",
    scrub: 1
  },
  x: coProductSection2ScrubFactorPos,
  y: coProductSection2ScrubFactorNeg
});
// 2
gsap.to(".co-product-section-2-images-frame-3-item-2>div", {
  scrollTrigger: {
    trigger: ".co-product-section-2-images",
    start: "top bottom",
    end: "bottom top",
    scrub: 1
  },
  x: coProductSection2ScrubFactorNeg,
  y: coProductSection2ScrubFactorNeg
});
// 3
gsap.to(".co-product-section-2-images-frame-3-item-3>div", {
  scrollTrigger: {
    trigger: ".co-product-section-2-images",
    start: "top bottom",
    end: "bottom top",
    scrub: 1
  },
  x: coProductSection2ScrubFactorPos,
  y: coProductSection2ScrubFactorPos
});
// 4
gsap.to(".co-product-section-2-images-frame-3-item-4>div", {
  scrollTrigger: {
    trigger: ".co-product-section-2-images",
    start: "top bottom",
    end: "bottom top",
    scrub: 1
  },
  x: coProductSection2ScrubFactorNeg,
  y: coProductSection2ScrubFactorPos
});


// ========================================================================================================== SECTION 3
// ===================================================== MARQUEE
const coProductSection3 = document.querySelector('.co-product-section-3-blog-slider');
if (coProductSection3) {
  coInitializeTickerCarousel({ selector: '.co-product-section-3-blog-slider', tickerSpeed: 0.5, prevNextButtons: true, rightScroll: false });
} else {
  gsap.set('.co-product-section-3-main-title', { opacity: 0, y: 0, transition: 0 });
  gsap.set('.co-product-section-3-main-button', { opacity: 0, y: 0, transition: 0 });
  gsap.set('.co-product-section-3-main-description', { opacity: 0, y: 0, transition: 0 });
  
  let coHomeSection9Timeline = gsap.timeline({ paused: true });
  coHomeSection9Timeline.to(".co-product-section-3-main-title", {
    duration: 1,
    ease: "power2.inOut",
    y: 0,
    opacity: 1
  }, "-=0.3");
  coHomeSection9Timeline.to(".co-product-section-3-main-description", {
    duration: 1,
    ease: "power2.inOut",
    y: 0,
    opacity: 1
  }, "-=0.9");
  coHomeSection9Timeline.to(".co-product-section-3-main-button", {
    duration: 1,
    ease: "power2.inOut",
    y: 0,
    opacity: 1
  }, "-=0.9");
  ScrollTrigger.create({
    trigger: '.co-product-section-3', start:'top bottom', end: "bottom top",
    animation: coHomeSection9Timeline
  });
}


// ========================================================================================================== SECTION 3 (DEC25)
(function() {
  'use strict';
  
  function setEqualHeights() {
    const titleElements = document.querySelectorAll('.co-product-dec-3-article-title');
    
    if (titleElements.length === 0) return;
    
    titleElements.forEach(el => el.style.height = 'auto');
    
    let maxHeight = 0;
    titleElements.forEach(el => {
      const height = el.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    
    titleElements.forEach(el => {
      el.style.height = maxHeight + 'px';
    });
  }

  const flkty = new Flickity('.co-product-dec-3-slider', {
    pageDots: false, 
    draggable: true,
    prevNextButtons: false,
    cellAlign: "left",
    contain: true,
    on: {
      ready: function() {
        setEqualHeights();
      },
      settle: function() {
        setEqualHeights();
      }
    }
  });
  
  window.addEventListener('resize', function() {
    flkty.resize();
    setEqualHeights();
  });
})();


// ========================================================================================================== SECTION 4 (DEC25)
class ImageCompare {
  constructor(element) {
    this.element = element;
    this.overlay = element.querySelector('.co-image-compare-overlay');
    this.slider = element.querySelector('.co-image-compare-slider');
    this.overlayImageWrapper = this.overlay.querySelector('.co-product-dec-4-compare-image');
    this.isResizing = false;

    this.init();
  }

  init() {
    this.updateDimensions();

    this.slider.addEventListener('mousedown', (e) => this.startResize(e));
    this.element.addEventListener('mousedown', (e) => this.startResize(e));

    this.slider.addEventListener('touchstart', (e) => this.startResize(e));
    this.element.addEventListener('touchstart', (e) => this.startResize(e));

    window.addEventListener('resize', () => this.updateDimensions());
  }

  updateDimensions() {
    const width = this.element.offsetWidth;
    if (this.overlayImageWrapper) {
      this.overlayImageWrapper.style.width = width + 'px';
      const img = this.overlayImageWrapper.querySelector('img');
      if (img) {
        img.style.width = width + 'px';
      }
    }
  }

  startResize(e) {
    e.preventDefault();
    this.isResizing = true;

    const x = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    this.updatePosition(x);

    const moveHandler = (e) => this.resize(e);
    const endHandler = () => this.endResize(moveHandler, endHandler);

    if (e.type.includes('touch')) {
      document.addEventListener('touchmove', moveHandler);
      document.addEventListener('touchend', endHandler);
    } else {
      document.addEventListener('mousemove', moveHandler);
      document.addEventListener('mouseup', endHandler);
    }
  }

  resize(e) {
    if (!this.isResizing) return;

    const x = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    this.updatePosition(x);
  }

  updatePosition(x) {
    const rect = this.element.getBoundingClientRect();
    let position = x - rect.left;

    position = Math.max(0, Math.min(position, rect.width));

    const percentage = (position / rect.width) * 100;

    this.overlay.style.width = percentage + '%';
    this.slider.style.left = percentage + '%';
  }

  endResize(moveHandler, endHandler) {
    this.isResizing = false;

    document.removeEventListener('mousemove', moveHandler);
    document.removeEventListener('mouseup', endHandler);
    document.removeEventListener('touchmove', moveHandler);
    document.removeEventListener('touchend', endHandler);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const comparison = document.querySelector('[data-comparison]');
  if (comparison) {
    new ImageCompare(comparison);
  }
});

document.querySelectorAll('.co-product-dec-4-header-text').forEach(el => {
  el.innerHTML = el.innerHTML.replace(/\bvs\b/gi, '<span class="co-product-dec-4-header-vs brandon-grotesque-black-regular">vs</span>');
});

// ========================================================================================================== SECTION 5 (DEC25)
(function() {
  'use strict';

  const flkty = new Flickity('.co-product-dec-5-slider', {
    pageDots: false, 
    draggable: true,
    wrapAround: true,
    prevNextButtons: false,
    cellAlign: "center",
    contain: true,
    on: {

    }
  });
  
})();
// ========================================================================================================== SECTION 6 (DEC25)
let coRegen8Groups = gsap.utils.toArray(".co-product-dec-6-accordion-group");
let coRegen8Menus = gsap.utils.toArray(".co-product-dec-6-accordion-menu");
let coRegen8MenuToggles = coRegen8Groups.map(createAnimation);
coRegen8Menus.forEach((menu) => {
  menu.addEventListener("click", () => coRegen8ToggleMenu(menu));
});
function coRegen8ToggleMenu(clickedMenu) {
  coRegen8MenuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
}
function createAnimation(element) {
  let menu = element.querySelector(".co-product-dec-6-accordion-menu");
  let box = element.querySelector(".co-product-dec-6-accordion-content");
  let minusElement = element.querySelector(".co-product-dec-6-accordion-open");
  let plusElement = element.querySelector(".co-product-dec-6-accordion-close");
  gsap.set(box, { height: "auto" });
  let animation = gsap
    .timeline()
    .from(box, {
      height: 0,
      duration: 0.3,
      ease: "power2.inOut"
    })
    .from(minusElement, { duration: 0.1, autoAlpha: 0, ease:"none" }, 0)
    .to(plusElement, { duration: 0.1, autoAlpha: 0, ease:"none" }, 0)
    .reverse();

  return function (clickedMenu) {
    if (clickedMenu === menu) {
      animation.reversed(!animation.reversed());
    } else {
      animation.reverse();
    }
  };
}
coRegen8ToggleMenu(coRegen8Menus[0])
